import React from "react";
import { useNavigate } from "react-router-dom";
import RegionMap from "../../components/RegionMap";

const RegionSelector: React.FC = () => {
  const navigate = useNavigate();

  const handleRegionClick = (nameRegion: string) => {
    navigate(`/region/${nameRegion}`);
  };

  return (
    <>
      {/* <GroupLogin /> rimosso, ora è solo nell'header globale */}
      <RegionMap onRegionClick={handleRegionClick} />
    </>
  );
};

export default RegionSelector;
